import React from 'react';
import { motion } from 'framer-motion';
import { FlameIcon } from 'lucide-react';
type ScarcityBarProps = {
  tone?: 'light' | 'dark';
};
const SPOTS_LEFT = 7;
const FILLED = 93;
export function ScarcityBar({
  tone = 'light'
}: ScarcityBarProps) {
  const dark = tone === 'dark';
  return <div className={`mx-auto mt-6 w-full max-w-md rounded-2xl p-4 ${dark ? 'bg-navy-800' : 'bg-white ring-1 ring-navy/10'}`} data-id="element-54" data-mp="2q3hfkwsm1of6">
      <div className="flex items-center justify-between gap-3 text-sm font-bold" data-id="element-55" data-mp="2b5p5ik5u1s8d">
        <span className={`flex items-center gap-1.5 ${dark ? 'text-white' : 'text-navy'}`} data-id="element-56" data-mp="2g63blwnvis3r">
          <FlameIcon className="h-4 w-4 text-alert" aria-hidden="true" data-id="element-57" data-mp="226lg6yg2oglf" />
          Only {SPOTS_LEFT} copies left
        </span>
        <span className="text-alert" data-id="element-58" data-mp="275y5rqybw1rp">{FILLED}% claimed</span>
      </div>
      <div className={`mt-2.5 h-4 w-full overflow-hidden rounded-full ${dark ? 'bg-navy-900' : 'bg-canvas'}`} role="progressbar" aria-valuenow={FILLED} aria-valuemin={0} aria-valuemax={100} aria-label="Introductory price copies claimed" data-id="element-59" data-mp="e5ly5wfkebk">
        <motion.div className="h-full rounded-full bg-alert" initial={{
        width: '60%'
      }} whileInView={{
        width: `${FILLED}%`
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} data-id="element-60" data-mp="2zlt65yl44r1n" />
      </div>
      <p className={`mt-2 text-center text-xs font-medium ${dark ? 'text-sky-light' : 'text-muted'}`} data-id="element-61" data-mp="2ko0u5geryks7">
        Only {SPOTS_LEFT} copies available at the introductory price
      </p>
    </div>;
}